import { Container, Stack, Typography } from '@mui/material';
import { get } from 'lodash';
import React, { useEffect, useState } from 'react';
import { getLocalstorageToken } from '../../../context/AuthHelper';
import GetRecord from '../../../lib/api/GetRecord';
import { APIS } from '../../../lib/constants/apis';
import { DisplayDayAndFullDate } from '../../../utils/formats';
import { removeDataKeys, removeNullDeep } from '../../../utils/helper';
import EInstellung from './structure/EInstellung';
import Nachrichten from './structure/Nachrichten';
import VorDerForderung from './structure/VorDerForderung';

import Schema from '../../../lib/paths/unternehmen_FULL_Paths.json';
import AntraegeInForderung from './structure/AntraegeInForderung';
const P = Schema.attributes;

function MeinBereich() {
	const [orgaDetails, setOrgaDetails] = useState({});
	useEffect(() => {
		const fetch = async () => {
			let res = await GetRecord(APIS.Organisation, get(getLocalstorageToken(), 'organisationId', -1));
			if (res) {
				setOrgaDetails(removeNullDeep(removeDataKeys(get(res, 'data'))));
			}
		};
		fetch();
	}, []);

	return (
		<>
			<Container>
				<Stack direction={'row'} justifyContent={'space-between'}>
					<Typography variant='h3' component='h2'>
						{' '}
						Willkommen, {get(orgaDetails, P.Geschaeftsbezogene_Daten_Name_Der_Organisation.path, '')}
					</Typography>
					<Typography variant='h3' component='h2'>
						{' '}
						{DisplayDayAndFullDate(new Date().toISOString())}
					</Typography>
				</Stack>
				<Nachrichten />
				<VorDerForderung />
				<AntraegeInForderung />
				<EInstellung />

				{/* </Grid> */}
			</Container>
		</>
	);
}

export default MeinBereich;
